import React, { useState, useEffect, useCallback, useContext } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'
import DatePicker, { CalendarContainer } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { AppColors } from '../css/AppColors';
import { Modal, Button } from 'react-bootstrap';
import { apiRequest } from '../utils/apiCalls';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { Context } from '../Context/DataContext';
import { useHistory, useLocation } from 'react-router';
import { getStoreData, getStoreDataFromLocal } from '../utils/functions';
import BackButton from '../Components/BackButton';




const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return useCallback(() => updateState({}), []);
}



const ViewPromotion = () => {


    const forceUpdate = useForceUpdate()
    const history = useHistory();
    const location = useLocation();

    const [startDate, setStartDate] = useState(new Date());

    const { state, setStoreData } = useContext(Context)

    const [selectedDate, setSelectedDate] = useState()
    const [loading, setLoading] = useState(false)
    const [promotionData, setPromotionData] = useState({
        prom_name: location?.state?.data?.prom_name,
        prom_type: location?.state?.data?.prom_type,
        prom_start_date: location?.state?.data?.prom_start_date,
        prom_end_date: location?.state?.data?.prom_end_date,
        prom_msg: location?.state?.data?.prom_msg,
    })

    const [prom_amount, setProm_amount] = useState(location?.state?.data?.prom_amount) //discount price enter by user
    const [prom_qty, setProm_qty] = useState(location?.state?.data?.prom_qty)
    const [promPrice, setPromPrice] = useState(location?.state?.data?.prom_price) //calculated promotion price



    function formatDate(dateObj) {

        if (dateObj.getMonth() < 10) {
            const month = "0" + dateObj.getMonth();
            if (dateObj.getDate() < 10) {
                const dat = "0" + dateObj.getDate();
                let date = dateObj.getFullYear() + "-" + month + "-" + dat;
                return date
                // props.onValueChange(date);
            }
            else {
                let date = dateObj.getFullYear() + "-" + month + "-" + dateObj.getDate()
                return date
                // props.onValueChange(date);
            }
        }
        else {
            if (dateObj.getDate() < 10) {
                const dat = "0" + dateObj.getDate()
                let date = dateObj.getFullYear() + "-" + dateObj.getMonth() + "-" + dat
                return date
                // props.onValueChange(date);
            }
            else {
                let date = dateObj.getFullYear() + "-" + dateObj.getMonth() + "-" + dateObj.getDate()
                return date
                // props.onValueChange(date);
            }

        }
    }

    function calculatePrice(qty) {

        var prodPrice = parseInt(location?.state.p_price);
        var prom_price = parseInt(prom_amount);

        if (!qty) {
            qty = prom_qty
        }
        // var qty = qty;
        if (promotionData.prom_type == 'fixed') {

            var price = (qty * prodPrice) - (qty * prom_price);
            setPromPrice(price)
        }
        else {

            var percentPrice = ((prodPrice * qty) / 100) * prom_price;
            var price = (qty * prodPrice) - (qty * percentPrice);
            setPromPrice(price)


        }

    }



    return (
        <div id="page-top">
            <div id="wrapper" >
                <Sidebar />
                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />


                        <div className="container-fluid" >
                            <Modal
                                show={loading}
                                onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>
                            {/* Page Wrapper */}
                            <div id="wrapper" >
                                {/* Content Wrapper */}
                                <div id="content-wrapper" className="d-flex flex-column" style={{ paddingBottom: 200 }} >
                                    {/* Main Content */}
                                    <div id="content">
                                        {/* Begin Page Content */}
                                        <div className="container-fluid">
                                            {/* Page Heading */}
                                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                                <h1 className="h3 mb-0 text-gray-800">View Promotion</h1>
                                            </div>
                                            <div className="row">
                                                {/* <form id="frm_customer"> */}
                                                {/* Page Heading */}
                                                {
                                                    promotionData.prom_msg &&

                                                    <div className="col-sm-12 mb-3 ">
                                                        <div className="editDetails" >Promotion Message</div>
                                                        <textarea
                                                            style={{ minHeight: 49 }}
                                                            disabled={true}
                                                            type="textarea"
                                                            className="form-control form-control-user"
                                                            placeholder={promotionData.prom_msg}
                                                        />
                                                    </div>
                                                }

                                                <div className="col-sm-3 " >
                                                    <div className="editDetails" style={{ fontSize: 13.5, }}>Product Name</div>
                                                    <input

                                                        type="text"
                                                        value={location.state?.prodData?.p_name}
                                                        disabled={true}
                                                        className="form-control form-control-user"
                                                        placeholder={location.state?.prodData?.p_name}
                                                    />
                                                    <br />
                                                </div>
                                                <div className="col-sm-2" style={{ fontSize: 13 }}>
                                                    <div className="editDetails" >Product Price</div>
                                                    <input
                                                        type="text"
                                                        value={location?.state?.prodData?.p_price}
                                                        disabled={true}
                                                        className="form-control form-control-user"
                                                        placeholder={location.state?.prodData?.p_price}
                                                    />
                                                    <br />
                                                </div>



                                                <div className="col-sm-2">
                                                    <div className="editDetails" style={{ fontSize: 13 }} >Actual Price</div>
                                                    <input
                                                        type="text"
                                                        value={location?.state?.prodData?.p_price * location?.state?.data?.prom_qty}
                                                        disabled={true}
                                                        className="form-control form-control-user"
                                                        placeholder={prom_qty ? location?.state.p_price * prom_qty : location?.state.p_price}
                                                    // placeholder={location?.state?.prodData?.p_price * location?.state?.data?.prom_qty}
                                                    />
                                                    <br />
                                                </div>

                                                <div className="col-sm-2">
                                                    <div className="editDetails" style={{ fontSize: 13 }} >Discounted Price</div>
                                                    <input
                                                        type="text"
                                                        value={promPrice}
                                                        disabled={true}
                                                        className="form-control form-control-user"
                                                        placeholder={promPrice}
                                                    />
                                                    <br />
                                                </div>

                                                <div className="form-group row">
                                                    <div className="col-sm-6">
                                                        <div className="editDetails" >Promotion Title</div>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-user"
                                                            placeholder="Promotion Title"
                                                            value={promotionData.prom_name}
                                                            disabled={true}

                                                        />
                                                        <br />
                                                    </div>
                                                    <div className="center col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >Discount type</div>
                                                        <select
                                                            title="Discount type"
                                                            disabled={true}
                                                            className="form-control form-control-user"
                                                            placeholder="Discount type"
                                                            value={promotionData.prom_type}

                                                        >
                                                            <option value="percent">Percent</option>
                                                            <option value="fixed">Fixed Amount </option>
                                                        </select>
                                                        <br />
                                                    </div>
                                                    <div className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >Discount</div>

                                                        <input
                                                            type="number"
                                                            disabled={true}
                                                            className="form-control form-control-user"
                                                            placeholder="Discount"
                                                            value={prom_amount}
                                                            onBlur={() => {
                                                                if (prom_qty) {
                                                                    calculatePrice()
                                                                }
                                                            }}

                                                        />
                                                        <br />
                                                    </div>
                                                    <div className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails"  >Promotion Quantity</div>
                                                        <input
                                                            type="number"
                                                            disabled={prom_amount ? false : true}
                                                            className="form-control form-control-user"
                                                            placeholder="Promotion Quantity"
                                                            value={prom_qty}
                                                            disabled={true}
                                                        />
                                                        <br />
                                                    </div>

                                                    <div
                                                        className="col-sm-6 mb-3 mb-sm-0"
                                                    >
                                                        <div className="editDetails" >Start data</div>
                                                        <DatePicker
                                                            className="form-control form-control-user"
                                                            disabled={true}
                                                            placeholderText="Start Date"
                                                            value={promotionData.prom_start_date}
                                                            selected={selectedDate}

                                                        />

                                                        <br />
                                                    </div>
                                                    <div
                                                        className="col-sm-6 mb-3 mb-sm-0"
                                                    >
                                                        <div className="editDetails" >End date</div>
                                                        <DatePicker
                                                            className="form-control form-control-user"
                                                            disabled={true}
                                                            placeholderText="End date"
                                                            value={promotionData.prom_end_date}
                                                        />
                                                        <br />
                                                    </div>
                                                </div>
                                                <BackButton />
                                            </div>
                                        </div>
                                        {/* /.container-fluid */}
                                    </div>
                                    {/* End of Main Content */}
                                </div>
                                {/* End of Content Wrapper */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ViewPromotion
